module.exports = __webpack_public_path__ + "h5/img/logo5.e9f8d865.png";